<template>
  <div :class="`${elementContainerClasses.join(' ')} ${! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-500' : ''}`">
    <VueResizable
      :active="activeSide"
      :ref="`resizable_${id}`"
      @resize:start="resetSize"
      @resize:end="updateSize"
      :maxWidth="maxWidth"
      width="100%"
      height="100%"
      :fitParent="false"
    >
      <div class="wf-relative wf-pb-2 wf-px-2 wf-pt-8 wf-h-full wf-flex z-40 wf-flex wf-items-stretch wf-w-full">
        <div v-show="! previewMode" class="wf-absolute wf-flex wf-top-0 wf-right-0 wf-mt-1 wf-mr-1 hover-target">
          <span class="wf-text-gray-600 wf-text-sm">form column</span>
          <button class="wf-ml-4" v-show="siblings.length > 1" @click.prevent="removeColumn"><i class="fas wf-text-sm wf-text-gray-500 hover:wf-text-gray-600 fa-trash"></i></button>
          <button class="wf-ml-4 form-column-handle "><i class="fas wf-text-sm wf-text-gray-500 hover:wf-text-gray-600 fa-arrows-alt"></i></button>
        </div>
        <component
          :withLabel="showLabels"
          :withPlaceholder="showPlaceholder"
          :labelStyles="labelStyles"
          :labelClasses="labelClasses"
          :styles="component.component == 'editor-form-input' ? inputStyles : buttonStyles"
          :classes="component.component == 'editor-form-input' ? inputClasses : buttonClasses"
          :is="component.component"
          v-for="component in components"
          :parentModule="parentModule"
          :key="component.id"
        />
        <div class="wf-flex wf-flex-col wf-w-full wf-items-end" v-if="! components.length">
          <button
            v-show="! previewMode"
            class="wf-w-full wf-uppercase wf-text-xs wf-font-bold wf-tracking-wide wf-self-end wf-text-gray-500 wf-text-center wf-border wf-border-dashed wf-border-gray-500 wf-px-4 wf-h-10 wf-w-full"
            @click.prevent="addInput"
          ><i class="fas fa-plus wf-mr-2"></i>add input</button>
          <button
            v-show="! formHasButton && ! previewMode"
            class="wf-w-full wf-uppercase wf-text-xs wf-font-bold wf-tracking-wide wf-self-end wf-text-blue-600 wf-mt-1 wf-text-center wf-border wf-border-dashed wf-border-blue-600 wf-px-4 wf-h-10 wf-w-full"
            @click.prevent="addButton"
          ><i class="fas fa-plus wf-mr-2"></i>add button</button>
        </div>
      </div>
    </VueResizable>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import VueResizable from 'vue-resizable'
  import EditorFormInput from './EditorFormInput'
  import {ConstantsParser} from '../ConstantsParser'
  import FormColumnWidths from '../mixins/FormColumnWidths'
  import ArrayManipulation from '../mixins/ArrayManipulation'
  import { FormInputFactory } from '../factories/FormInputFactory'
  import { FormButtonFactory } from '../factories/FormButtonFactory'
  export default {
    props: {
      parentModule: {
        type: String,
        required: false
      }
    },
    mixins: [ArrayManipulation, FormColumnWidths],
    components: {draggable, EditorFormInput, VueResizable},
    watch: {
      siblings(value, oldValue) {
        if (value.length < oldValue.length) {
          return this.updateFormColumnWidth(value.length)
        }
      },
    },
     mounted() {
      this.$refs[`resizable_${this.id}`].w = '100%'
      this.$refs[`resizable_${this.id}`].h = '100%'
     },
    computed: {
      widths() {
        return {
          'WIDTH_3_12': {
            value: 3,
            classes: {
              phone: [
                {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
              ],
              tablet: [
                {property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false}
              ],
              desktop: [
                {property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false}
              ]
            },
            maxPercentageSize: .25
          },
          'WIDTH_4_12': {
            value: 4,
            classes: {
              phone: [
                {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
              ],
              tablet: [
                {property: 'ColumnWidth', value: 'WIDTH_4_12', touched: false}
              ],
              desktop: [
                {property: 'ColumnWidth', value: 'WIDTH_4_12', touched: false}
              ]
            },
            maxPercentageSize: .33
          },
          'WIDTH_6_12': {
            value: 6,
            classes: {
              phone: [
                {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
              ],
              tablet: [
                {property: 'ColumnWidth', value: 'WIDTH_6_12', touched: false}
              ],
              desktop: [
                {property: 'ColumnWidth', value: 'WIDTH_6_12', touched: false}
              ]
            },
            maxPercentageSize: .5
          },
          'WIDTH_9_12': {
            value: 9,
            classes: {
              phone: [
                {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
              ],
              tablet: [
                {property: 'ColumnWidth', value: 'WIDTH_9_12', touched: false}
              ],
              desktop: [
                {property: 'ColumnWidth', value: 'WIDTH_9_12', touched: false}
              ]
            },
            maxPercentageSize: .75
          },
          'WIDTH_12_12': {
            value: 12,
            classes: {
              phone: [
                {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
              ],
              tablet: [
                {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
              ],
              desktop: [
                {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
              ]
            },
            maxPercentageSize: 1
          }
        }
      },
      index() {
        return this.siblings.findIndex(formColumn => formColumn.id == this.id)
      },
      maxWidth() {
        return window.innerWidth
      },
      activeSide() {
        return this.isResizable ? ['r'] : []
      },
      isResizable() {
        return this.siblings.length > 1 && this.index < this.siblings.length - 1
      }, 
      previewMode() {
        return this.$store.state.previewMode
      },
      module() {
        return this.parent.module
      },
      formHasButton() {
        return !! this.parent.form.content.rows.find(row => row.columns.find(column => column.components.find(component => component.component === 'editor-form-button')))
      },
      id() {
        return this.$vnode.key
      },
      siblings() {
        return this.parent.formColumns
      },
      device() {
        return this.parent.device
      },
      parent() {
        return this.$parent.$parent
      },
      formElement() {
        return this.parent.formElement
      },
      components: {
        get() {
          return this.parent.formColumns.find(formColumn => formColumn.id === this.id).components
        },
        set(value) {
          let element = Array.from(this.parent.parent.formRows).map(formRow => {
            if(formRow.id != this.parent.id) {
              return formRow
            }
            let columns = formRow.columns.map(formColumn => {
              if (formColumn.id != this.id) {
                return formColumn
              }
              return {...formColumn, components: value}
            })
            return {...formRow, columns: columns}
          })
          this.addToObject(this.module, {rows: element}, 'content', null, this.formElement, true, this.parentModule)
        }
      },
      containerClasses() {
        return this.parent.formColumns.find(formColumn => formColumn.id == this.id).containerClasses
      },
      elementContainerClasses() {
        return (new ConstantsParser(this.containerClasses, this.parent.parent.device)).parse()
      },
      buttonClasses() {
        return this.parent.form.buttonClasses
      },
      buttonStyles() {
        return this.parent.form.buttonStyles
      },
      labelClasses() {
        return this.parent.form.labelClasses
      },
      labelStyles() {
        return this.parent.form.labelStyles
      },
      inputClasses() {
        return this.parent.form.inputClasses
      },
      inputStyles() {
        return this.parent.form.inputStyles
      },
      showLabels() {
        return this.parent.form.content.showLabels
      },
      showPlaceholder() {
        return this.parent.form.content.showPlaceholder
      }
    },
    methods: {
      getWidthClasses(width) {
        let widthFound = Object.keys(this.widths).find(availableWidth => {
          return width <= this.widths[availableWidth].maxPercentageSize
        })
        if (! widthFound) {
          return this.widths['WIDTH_12_12'].classes
        }
        return this.widths[widthFound].value
      },
      resetSize(event) {
        if (event.width == '100%') {
          let resizeElementWidth = this.$refs[`resizable_${this.id}`].$el.offsetWidth
          this.$refs[`resizable_${this.id}`].w = resizeElementWidth
        }
      },
      updateSize(event) {
        let width = event.width / window.innerWidth
        if (width > .75) {
          width = .75
        }
        if (! this.isResizable) {
          return this.$refs[`resizable_${this.id}`].w = '100%'
        }
        let newSize = this.getWidthClasses(width)
        let classes = Object.keys(this.widths).find(width => this.widths[width].value == newSize)
        classes = this.widths[classes].classes
        if (newSize > this.maxPossibleSize) {
          classes = this.widths['WIDTH_12_12'].classes
        }
        this.updateNextSiblingSize(classes)
        this.updateColumnSize(classes)
      },
      updateNextSiblingSize(classes) {
        let originalSize = this.siblings[this.index]
           .containerClasses[this.device]
           .find(contClass => contClass.property == 'ColumnWidth').value
        originalSize = this.widths[originalSize].value
        let newSize = classes[this.device].find(colClass => colClass.property == 'ColumnWidth').value
        newSize = this.widths[newSize].value
        if (newSize == 'WIDTH_12_12') {
          newSize = 9
        }
        let changeToNextColumn = newSize - originalSize
        let nextColumnIndex = this.index + 1
        let nextColumn = this.siblings[nextColumnIndex]
        let nextColumnSize = nextColumn.containerClasses[this.device].find(contClass => contClass.property == 'ColumnWidth').value
        nextColumnSize = this.widths[nextColumnSize].value - changeToNextColumn
        if (nextColumnSize < 1) {
          nextColumnSize = 3
        }
        let newWidth = Object.keys(this.widths).find(width => this.widths[width].value == nextColumnSize)
        newWidth = this.widths[newWidth].classes[this.device]
        let element = Array.from(this.parent.parent.formRows).map(formRow => {
          if(formRow.id != this.parent.id) {
            return formRow
          }
          let columns = formRow.columns.map((formColumn, formColumnIndex) => {
            if (formColumnIndex != nextColumnIndex) {
              return formColumn
            }
            let containerClassesObject = {
              desktop: newWidth,
              tablet: newWidth,
              phone: newWidth,
            }
            return {...formColumn, containerClasses: containerClassesObject}
          })
          return {...formRow, columns: columns}
        })
        this.addToObject(this.module, {rows: element}, 'content', null, this.formElement, true, this.parentModule)
      },
      updateColumnSize(classes) {
        let element = Array.from(this.parent.parent.formRows).map(formRow => {
          if(formRow.id != this.parent.id) {
            return formRow
          }
          let columns = formRow.columns.map(formColumn => {
            if (formColumn.id != this.id) {
              return formColumn
            }
            return {...formColumn, containerClasses: classes}
          })
          return {...formRow, columns: columns}
        })
        this.addToObject(this.module, {rows: element}, 'content', null, this.formElement, true, this.parentModule)
        this.$refs[`resizable_${this.id}`].w = '100%'
      },
      addButton() {
        let element = Array.from(this.parent.parent.formRows).map(formRow => {
          if(formRow.id != this.parent.id) {
            return formRow
          }
          let columns = formRow.columns.map(formColumn => {
            if (formColumn.id != this.id) {
              return formColumn
            }
            return {...formColumn, components: [...formColumn.components, (new FormButtonFactory).create()]}
          })
          return {...formRow, columns: columns}
        })
        this.addToObject(this.module, {rows: element}, 'content', null, this.formElement, true, this.parentModule)
      },
      updateFormColumnWidth(formColumnsLength) {
        let size = this.availableSizes[Object.keys(this.availableSizes).find(size => this.availableSizes[size].columns.length == formColumnsLength)]
        size.columns.forEach((column, index) => {
          let formColumn = {...this.parent.formColumns[index], containerClasses: column.containerClasses}
          this.updateFormColumn(formColumn)
        })
      },
      updateFormColumn(newFormColumn) {
        let rows = Array.from(this.parent.parent.formRows).map(formRow => {
          if (formRow.id != this.parent.id) {
            return formRow
          }
          let columns = formRow.columns.map(formColumn => {
            if (formColumn.id != newFormColumn.id) {
              return formColumn
            }
            return newFormColumn
          })
          return {...formRow, columns: columns}
        })
        this.addToObject(this.module, {rows: rows}, 'content', null, this.formElement, true, this.parentModule)
      },
      addInput() {
        let element = Array.from(this.parent.parent.formRows).map(formRow => {
          if(formRow.id != this.parent.id) {
            return formRow
          }
          let columns = formRow.columns.map(formColumn => {
            if (formColumn.id != this.id) {
              return formColumn
            }
            return {...formColumn, components: [...formColumn.components, (new FormInputFactory).create()]}
          })
          return {...formRow, columns: columns}
        })
        this.addToObject(this.module, {rows: element}, 'content', null, this.formElement, true, this.parentModule)
      },
      removeColumn() {
        let element = Array.from(this.parent.parent.formRows).map(formRow => {
          if(formRow.id != this.parent.id) {
            return formRow
          }
          let columns = formRow.columns.filter(formColumn => formColumn.id != this.id)
          return {...formRow, columns: columns}
        })
        this.addToObject(this.module, {rows: element}, 'content', null, this.formElement, true, this.parentModule)
      }
    }
  }
</script>